(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	$('input[type=range]').each(function () {
		var input = $(this);
		var unit = input.attr('data-unit') || '';
		var output = $('<output></output>').insertAfter(input);

		output.text(input.val() + ' ' + unit);

		input.on('input change', function () {
			output.text(input.val() + ' ' + unit);
		});
	});
})();
